import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';
import { CollectionManageAccessFacade, CollectionMoveToFacade, SpacesIndexViewFacade } from '@mode/collections/domain';

export const DowngradedCollectionsDomainModule = angular
  .module('downgraded-collections-domain', [])
  .service('CollectionManageAccessFacade', downgradeInjectable(CollectionManageAccessFacade))
  .service('CollectionMoveToFacade', downgradeInjectable(CollectionMoveToFacade))
  .service('SpacesIndexViewFacade', downgradeInjectable(SpacesIndexViewFacade)).name;
